
import React  from 'react';
import {TextField} from '../FormFields/formFields';
import LoginActions from '../Login/LoginActions';



export default class termAndConditions extends React.Component {

    constructor(props){
		super(props);
    }
            
   
	render(){ 

           
            return(
                                                               
                <TextField
                Rules={this.props.Rules.TacChecked}
                classes="input-100 tac"
                name="Tac"
                ref="Tac"
                handleChange={LoginActions.toggleTac}
                fieldType="checkbox"
                TacText={this.props.TacText}
                TacUrl ={this.props.TacUrl}
                value  ={this.props.value}
                /> 
                
            )
    }
}


// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/Login/TermAndConditions.js